import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from '../components/Carousel';
import { usePageLastUpdated } from '../hooks/usePageLastUpdated';
import './ProjectsPage.css';

const PAGE_LAST_UPDATED = { dateTime: '2014-01-28', displayDate: 'January 28, 2014' };

const ProjectsPage = () => {
  usePageLastUpdated(PAGE_LAST_UPDATED);

  const carouselSlides = [
    {
      backgroundImage: '/images/banner_planetlab.png',
      content: (
        <>
          <p>The software that makes it easy to manage your PlanetLab experiments.</p>
          <p>
            The PlanetLab Manager is a desktop application that allows you to configure the PlanetLab
            site, nodes and slices for your experiments. Using the integrated secure shell (SSH)
            console you can run commands directly on the PlanetLab nodes.
          </p>
          <p>
            <Link
              to="/projects/inetanalytics/planetlab"
              title="Go to the PlanetLab Manager web page."
            >
              More information...
            </Link>
          </p>
        </>
      ),
    },
    {
      backgroundImage: '/images/banner_mercury.png',
      content: (
        <>
          <p>Today, the Internet Service Provider (ISP) market is very competitive.</p>
          <p>
            When ISPs compete for customers with the latest best offers, a question that begs for
            answers is: how well is your ISP connected to your favorite web sites?
          </p>
          <p>
            Help us find out, by joining our Mercury Internet measurement project and testing your
            Internet connection.
          </p>
          <p>
            <Link
              to="/projects/inetanalytics/mercury"
              title="Collaborate to the Mercury Internet measurement project."
            >
              I want to participate...
            </Link>
          </p>
        </>
      ),
    },
    {
      backgroundImage: '/images/banner_pilot53.png',
      content: (
        <>
          <p>
            Your assistant to drive on{' '}
            <a
              href="https://aws.amazon.com/"
              title="Go to the web site of Amazon Web Services."
              target="_blank"
              rel="noopener"
              className="external"
            >
              Amazon Web Services
            </a>{' '}
            Route 53.
          </p>
          <p>
            A free GUI application to help you manage your{' '}
            <a
              href="https://aws.amazon.com/route53/"
              title="Go to the web page of AWS Route 53."
              target="_blank"
              rel="noopener"
              className="external"
            >
              Route 53
            </a>{' '}
            account. You can configure your DNS zones and resource records from a single, flexible
            and easy to use interface.
          </p>
          <p>Available for download soon.</p>
        </>
      ),
    },
  ];

  const projects = [
    {
      to: '/projects/inetanalytics',
      image: '/images/projects/inetanalytics.png',
      title: 'Internet Analytics',
      description: 'A software platform for Internet measurements.',
    },
    {
      to: '/projects/inetanalytics/mercury',
      image: '/images/projects/mercury.png',
      title: 'Mercury Client',
      description: 'Collaborate to an experiment to discover the connectivity of your ISP.',
    },
    {
      to: '/projects/inetanalytics/planetlab',
      image: '/images/projects/planetlab.png',
      title: 'PlanetLab Manager',
      description: 'A software to manage your PlanetLab experiments.',
    },
    {
      to: '/projects/ytcrawler/release1',
      image: '/images/projects/project.png',
      title: 'YT Crawler',
      description: 'An application to crawl the information of YouTube videos.',
    },
    {
      to: '/projects/simstream',
      image: '/images/projects/project.png',
      title: 'SimStream',
      description: 'An efficient network simulator for large scale video streaming applications.',
    },
    {
      to: '/projects/simworker',
      image: '/images/projects/project.png',
      title: 'SimWorker',
      description: 'A library for parallel execution in discrete event simulations.',
    },
  ];

  return (
    <>
      <Carousel slides={carouselSlides} />
      <div className="projects-page">
        <div className="projects-grid">
          {projects.map((project, index) => (
            <Link
              key={index}
              to={project.to}
              className="project-card"
              style={{ backgroundImage: `url(${project.image})` }}
            >
              <span className="project-card-title">{project.title}</span>
              <span className="project-card-text">{project.description}</span>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};

export default ProjectsPage;
